import { ADMIN_COMMANDER_URL, COMMANDER_URL, REPLAY_URL } from "./commander";
import { getLoginInfo, getLoginInfoByEmail } from "../services/adminService";

export const goToAdminCommanderByEmail = (email: string, jwtToken: string) => {
  goToUrlByEmail(email, jwtToken, ADMIN_COMMANDER_URL);
};

export const goToCommanderByEmail = (email: string, jwtToken: string) => {
  goToUrlByEmail(email, jwtToken, COMMANDER_URL);
};

export const goToAdminCommanderByUserId = (userId: string, jwtToken: string) => {
  goToUrlByUserId(userId, jwtToken, ADMIN_COMMANDER_URL);
};

export const goToReplayByUserId = (userId: string, jwtToken: string) => {
    goToUrlByUserId(userId, jwtToken, REPLAY_URL);
};

export const goToCommanderByUserId = (userId: string, jwtToken: string) => {
  goToUrlByUserId(userId, jwtToken, COMMANDER_URL);
};

const goToUrlByEmail = (email: string, jwtToken: string, url: string) => {
  getLoginInfoByEmail(email, jwtToken)
    .then((response) => {
      if (response.status === 200) {
        const data = response.data;
        const win = window.open(`${url}?token=${data.jwtToken}&fbtoken=${data.firebaseToken}`, "_self");
        // @ts-ignore
        win.focus();
      } else {
        alert("Couldn't get login credentials");
      }
    })
    .catch((response) => alert("Couldn't get login credentials"));
};

const goToUrlByUserId = (userId: string, jwtToken: string, url: string) => {
  getLoginInfo(userId, jwtToken)
    .then((response) => {
      if (response.status === 200) {
        const data = response.data;
        const win = window.open(`${url}?token=${data.jwtToken}&fbtoken=${data.firebaseToken}`, "_self");
        // @ts-ignore
        win.focus();
      } else {
        alert("Couldn't get login credentials");
      }
    })
    .catch((response) => alert("Couldn't get login credentials"));
};
